import * as _clone2 from "clone";

var _clone = "default" in _clone2 ? _clone2.default : _clone2;

var exports = {};
var clone = _clone;

exports = function (options, defaults) {
  options = options || {};
  Object.keys(defaults).forEach(function (key) {
    if (typeof options[key] === "undefined") {
      options[key] = clone(defaults[key]);
    }
  });
  return options;
};

export default exports;